import React from "react";
import { client } from "../../../service/ApolloClient/ApolloClient";
import { QUERY_USER } from "../../../service/ApolloClient/ApolloQueries";

class ShowUserAudit extends React.Component {
  loading = false;

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      user: null,
    };
  }

  componentDidMount() {
    this.getUser(this.props.userId);
  }

  async getUser(id) {
    const query = await client.query({
      query: QUERY_USER,
      variables: {
        id: parseInt(id),
      },
      fetchPolicy: "cache-first",
    });

    this.setState({
      loading: false,
      user: query.data?.user,
    });
  }

  render() {
    return this.state.loading ? (
      <span>{this.props.userId}</span>
    ) : (
      <span>
        {this.state.user?.name}-{this.state.user?.lastname}
      </span>
    );
  }
}

export default ShowUserAudit;
